import React, { useState, useEffect, useContext } from "react";
import StateContext from "../../helpers/ContextState";
import Config from '../../helpers/Config';
import { PostAsync, format } from "../../helpers/Functions";
import Input from "../../components/InputSimple";
import SelectorMultiple from "../../components/SelectorMultiple";

const App = () => {
  const context = useContext(StateContext);

  const getParamsFromUrl = () => {
    const parts = window.location.pathname.split("/").filter(Boolean);
    return {
      cliente_id:             parts[3] || "",
      semestre:               parts[4] || "",
      op_inventario_items_id: parts[5] || "",
    };
  };

  const [inputs, setInputs]             = useState({ pago_fecha_inicio: "", pago_fecha_fin: "" });
  const [inputs2, setInputs2]           = useState({});
  const [data, setData]                 = useState([]);
  const [cliente, setCliente]           = useState(null);
  const [marcas, setMarcas]             = useState([]);
  const [totalizacion, setTotalizacion] = useState({});
  const [totalLineas, setTotalLineas]   = useState([]);
  const [totalLineasPeso, setTotalLineasPeso]   = useState([]);
  const [totalLineasTotal, setTotalLineasTotal] = useState([]);
  const [loading, setLoading]           = useState(true);

  const onChangeCustom = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => { getInit(); }, [inputs, inputs2]);

  const getInit = () => {
    const p = getParamsFromUrl();
    if (!p.cliente_id) { setLoading(false); return; }

    setLoading(true);
    setData([]);

    PostAsync(
      "Informes",
      "ListadoMediosMagneticosVentasDetalle",
      {
        cliente_id:             p.cliente_id,
        semestre:               p.semestre,
        op_inventario_items_id: p.op_inventario_items_id,
        filtroMultiple:         JSON.stringify(inputs2),
        ...inputs,
      },
      context
    ).then((response) => {
      setLoading(false);
      if (!response || response.error) return;

      if (response.proveedor)    setCliente(response.proveedor);
      if (response.marcas)       setMarcas(response.marcas);
      if (response.totalizacion) setTotalizacion(response.totalizacion);

      if (response.rows && response.rows.length > 0) {
        const grouped = {};
        response.rows.forEach((row) => {
          const key = row.producto_nombre;
          if (!grouped[key]) grouped[key] = [];
          grouped[key].push(row);
        });

        const data_             = [];
        const totalLineas_      = [];
        const totalLineasPeso_  = [];
        const totalLineasTotal_ = [];

        Object.entries(grouped).forEach(([label, items]) => {
          data_.push({ label, items });
          totalLineas_.push(items.reduce((s, r) => s + parseFloat(r.cantidad || 0), 0));
          totalLineasPeso_.push(items.reduce((s, r) => s + parseFloat(r.peso || 0), 0));
          totalLineasTotal_.push(items.reduce((s, r) => s + parseFloat(r.subtotal_linea || 0), 0));
        });

        setData(data_);
        setTotalLineas(totalLineas_);
        setTotalLineasPeso(totalLineasPeso_);
        setTotalLineasTotal(totalLineasTotal_);
      }
    });
  };

  const calcTotalMasIva = () => {
    const sub = parseFloat(totalizacion.subtotal || 0);
    const iva = parseFloat(totalizacion.iva || 0);
    return format(sub + iva);
  };

  const emptyTds = (n) => Array.from({ length: n }).map((_, i) => <td key={i}></td>);

  return (
    <div className="container-fluid" style={{ marginTop: '60px' }}>

      <div className="row justify-content-center mb-3">
        {cliente && (
          <>
            <b className="h4"><strong>Cliente:</strong> {cliente.proveedor_nombre}</b>
            <b className="h4 mb-3"><strong>NIT:</strong> {cliente.proveedor_cedula}</b>
          </>
        )}
      </div>

      <div className="row mb-2">
        <div className="col text-end">
          <a
            href={`${Config.ConfigApirest}Excel/Informes/ListadoMediosMagneticosVentasDetalleExcel/token:${context.user.token}?cliente_id=${getParamsFromUrl().cliente_id}&semestre=${getParamsFromUrl().semestre}&op_inventario_items_id=${getParamsFromUrl().op_inventario_items_id}&pago_fecha_inicio=${inputs.pago_fecha_inicio}&pago_fecha_fin=${inputs.pago_fecha_fin}&filtroMultiple=${encodeURIComponent(JSON.stringify(inputs2))}`}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary me-2"
          >
            Exportar
          </a>
          <a
            href={`${Config.ConfigApirest}PDF/Informes/ListadoMediosMagneticosVentasDetalle/${context.user.token}?cliente_id=${getParamsFromUrl().cliente_id}&semestre=${getParamsFromUrl().semestre}&op_inventario_items_id=${getParamsFromUrl().op_inventario_items_id}&pago_fecha_inicio=${inputs.pago_fecha_inicio}&pago_fecha_fin=${inputs.pago_fecha_fin}&filtroMultiple=${encodeURIComponent(JSON.stringify(inputs2))}`}
            target="_blank"
            rel="noreferrer"
            className="btn btn-secondary"
          >
            PDF
          </a>
        </div>
      </div>

      <div className="row bg-gray small">
        <div className="col-12 small"><b>Filtros de venta</b></div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left">
          <Input
            defaultValue={inputs.pago_fecha_inicio}
            title="Fecha desde"
            placeholder="Fecha desde"
            type="date"
            name="pago_fecha_inicio"
            className="form-control"
            onChange={onChangeCustom}
            required={true}
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left">
          <Input
            defaultValue={inputs.pago_fecha_fin}
            title="Fecha hasta"
            placeholder="Fecha hasta"
            type="date"
            name="pago_fecha_fin"
            className="form-control"
            onChange={onChangeCustom}
            required={true}
          />
        </div>
        <div className="col-12 col-sm-3 mb-3 pt-1 text-left border-end">
          <SelectorMultiple
            name="marca_id"
            title="Marca"
            selectDefault="Marca"
            data={marcas}
            inputs={inputs2}
            setInputs={setInputs2}
            className="form-control"
          />
        </div>
      </div>

      <div className="row">
        <div className="col">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-secondary" role="status" />
            </div>
          ) : data.length === 0 ? (
            <div className="alert alert-info mt-3">No hay registros para mostrar.</div>
          ) : (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="col text-center small">Producto</th>
                  <th className="col text-center small">Fecha de Venta</th>
                  <th className="col text-center small">Marca</th>
                  <th className="col small">Observacion</th>
                  <th className="col small">Cantidad</th>
                  <th className="col small">Peso</th>
                  <th className="col small">Precio Unitario</th>
                  <th className="col small">Subtotal</th>
                  <th className="col small">IVA</th>
                  <th className="col small">Reteiva</th>
                  <th className="col small">Reteica</th>
                  <th className="col small">Retefuente</th>
                  <th className="col small">Total</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, key) => (
                  <tr key={key}>
                    <td className="small">{row.label}</td>

                    <td className="text-center small">
                      {row.items.map((r, k) => (
                        <div className="mb-4" key={k}>{r.fecha_pago_string || "—"}</div>
                      ))}
                    </td>

                    <td className="text-center small">
                      {row.items.map((r, k) => (
                        <div className="mb-4" key={k} title={r.marca_nombre || ""}>
                          {r.marca_nombre
                            ? r.marca_nombre.length > 15
                              ? r.marca_nombre.substr(0, 15) + "..."
                              : r.marca_nombre
                            : "—"}
                        </div>
                      ))}
                    </td>

                    <td className="text-center small">
                      {row.items.map((r, k) => (
                        <div className="mb-4" key={k} title={r.observacion || ""} style={{ minHeight: "22px" }}>
                          {r.observacion
                            ? r.observacion.length > 15
                              ? r.observacion.substr(0, 15) + "..."
                              : r.observacion
                            : ""}
                        </div>
                      ))}
                    </td>

                    <td className="text-end small">
                      <div className="bg-secondary">
                        {row.items.map((r, k) => (
                          <div className="mb-4 text-white pe-2" key={k}>{r.cantidad_format}</div>
                        ))}
                        <div className="bg-secondary text-white p-2"><b>{format(totalLineas[key])}</b></div>
                      </div>
                    </td>

                    <td className="text-end small">
                      <div className="bg-secondary">
                        {row.items.map((r, k) => (
                          <div className="mb-4 text-white pe-2" key={k}>{r.peso_format}</div>
                        ))}
                        <div className="bg-secondary text-white p-2"><b>{format(totalLineasPeso[key])}</b></div>
                      </div>
                    </td>

                    <td>
                      <div className="text-end small">
                        {row.items.map((r, k) => (
                          <div className="mb-4 pe-2" key={k}>{r.precio_format}</div>
                        ))}
                      </div>
                    </td>

                    <td className="text-end text-white small">
                      <div className="bg-secondary">
                        {row.items.map((r, k) => (
                          <div className="mb-4 text-white pe-2" key={k}>{r.subtotal_format}</div>
                        ))}
                        <div className="bg-secondary text-white p-2"><b>{format(totalLineasTotal[key])}</b></div>
                      </div>
                    </td>

                    <td className="text-end small">
                      {row.items.map((r, k) => (<div className="mb-4 pe-2" key={k}>{r.iva_format}</div>))}
                    </td>
                    <td className="text-end small">
                      {row.items.map((r, k) => (<div className="mb-4 pe-2" key={k}>{r.reteiva_format}</div>))}
                    </td>
                    <td className="text-end small">
                      {row.items.map((r, k) => (<div className="mb-4 pe-2" key={k}>{r.reteica_format}</div>))}
                    </td>
                    <td className="text-end small">
                      {row.items.map((r, k) => (<div className="mb-4 pe-2" key={k}>{r.retefuente_format}</div>))}
                    </td>
                    <td className="text-end small">
                      {row.items.map((r, k) => (<div className="mb-4 pe-2" key={k}>{r.total_format}</div>))}
                    </td>
                  </tr>
                ))}
              </tbody>

              <tr>{emptyTds(11)}<td className="bg-primary text-white p-1 small">SUBTOTAL:</td><td className="bg-secondary text-white p-1 font-bold">{totalizacion.subtotal_format}</td></tr>
              <tr>{emptyTds(11)}<td className="bg-primary text-white p-1 small">IVA:</td><td className="bg-secondary text-white p-1 font-bold">{totalizacion.iva_format}</td></tr>
              <tr>{emptyTds(11)}<td className="bg-primary text-white p-1 small">TOTAL:</td><td className="bg-secondary text-white p-1 font-bold">{calcTotalMasIva()}</td></tr>
              <tr>{emptyTds(11)}<td className="bg-primary text-white p-1 small">RETEIVA:</td><td className="bg-secondary text-white p-1 font-bold">{totalizacion.reteiva_format}</td></tr>
              <tr>{emptyTds(11)}<td className="bg-primary text-white p-1 small">RETEICA:</td><td className="bg-secondary text-white p-1 font-bold">{totalizacion.reteica_format}</td></tr>
              <tr>{emptyTds(11)}<td className="bg-primary text-white p-1 small">RETEFUENTE:</td><td className="bg-secondary text-white p-1 font-bold">{totalizacion.retefuente_format}</td></tr>
              <tr>{emptyTds(11)}<td className="bg-primary text-white p-1 small">TOTAL VENDIDO:</td><td className="bg-primary text-white p-1"><strong style={{ color: "white" }}>{totalizacion.total_format}</strong></td></tr>
            </table>
          )}
        </div>
      </div>

    </div>
  );
};

export default App;
